import { BaseExportModal, ExportModalProps } from './ExportModal'
import { K12_COLUMNS } from 'components/DataExpansionComponents/K12/K12ColumnsInfo'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { getCommonChainProxyExportColumns } from 'components/DataExpansionComponents/Common/commonExportColumns'
import { useDownload } from 'features/download-widget'
import {
  getDownloadStatus,
  startK12DistrictsExportV2,
} from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

export function K12DistrictExportModal(props: ExportModalProps) {
  const k12ColumnHelper = createExportColumnHelper({
    columns: K12_COLUMNS,
  })

  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )
  const { startDownload } = useDownload()

  const columns = [
    {
      title: 'Target Attributes',
      elements: [
        k12ColumnHelper.retrieveColumn('lea_name'),
        k12ColumnHelper.retrieveColumn('address'),
        k12ColumnHelper.retrieveColumn('lcity'),
        k12ColumnHelper.retrieveColumn('lstate'),
        k12ColumnHelper.retrieveColumn('zipcode'),
        k12ColumnHelper.retrieveColumn('phone'),
        k12ColumnHelper.retrieveColumn('domain'),
        k12ColumnHelper.retrieveColumn('gslo'),
        k12ColumnHelper.retrieveColumn('gshi'),
        k12ColumnHelper.retrieveColumn('student_count'),
        k12ColumnHelper.retrieveColumn('teachers_count'),
        k12ColumnHelper.retrieveColumn('operational_schools'),
        k12ColumnHelper.retrieveColumn('revenue'),
        k12ColumnHelper.retrieveColumn('google_place_url'),
      ],
    },
    {
      title: 'Dining Services',
      elements: [
        k12ColumnHelper.retrieveColumn('food_service_expenditures'),
        k12ColumnHelper.retrieveColumn('free_lunch'),
        k12ColumnHelper.retrieveColumn('reduced_lunch'),
        k12ColumnHelper.retrieveColumn('total_supplemented_lunch'),
        k12ColumnHelper.retrieveColumn('uncategorized_lunch'),
        k12ColumnHelper.retrieveColumn('free_lunch_perc'),
        k12ColumnHelper.retrieveColumn('reduced_lunch_perc'),
        k12ColumnHelper.retrieveColumn('total_supplemented_lunch_perc'),
        k12ColumnHelper.retrieveColumn('uncategorized_lunch_perc'),
        k12ColumnHelper.retrieveColumn('estimated_meals_per_day'),
      ],
    },
    {
      title: 'Predicted Values and Deals',
      elements: getCommonChainProxyExportColumns(),
    },
  ]

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting K-12 Districts...' }],
      initiate: async () => {
        const { sort, ...filterWithoutSort } = (props.filters ?? {}) as Record<
          string,
          unknown
        >
        const response = await startK12DistrictsExportV2({
          selected_columns: selectedCols,
          export_type: exportType,
          filter_params: {
            ...filterWithoutSort,
            include_ids: props.selectedIds ?? [],
            exclude_ids: props.excludeIds ?? [],
          },
          sort: sort as string | undefined,
        })
        return { type: 'async', requestId: response.request_id }
      },
      getStatus: getDownloadStatus,
      label: 'K-12 Districts',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for K-12 Districts Download"
      subTitle="Download up to 10,000 K-12 Districts at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export K-12 Districts"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
